export const filterKeyQnA = 'QnA';
export const filterKeyArticle = 'article';
export const filterKeyVideo = 'video';
export const filterKeyTopics = 'tags';
export const filterKeyProducts = 'products';
export const filterKeyCategory = 'category';

export const hideTitle = [filterKeyProducts];

export const all_count = 4;

export const noResultsGeneralItems = [
  {
    _id: '3985',
    itemType: 'MYLO_CATEGORIES',
    itemName: 'Mylo Care Categories',
    heading: '',
    itemHeading: 'Explore Mylo Care',
    headingAlignment: 'TOP',
    headingRightIcon: '',
    cardView: true,
    showCta: false,
    getFromCache: false,
    viewType: 'GRID',
    gridSize: 3,
    items: [
      {
        _id: '4109',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Skin',
        icon: 'https://images.myloapp.in/NestJsUploads/1695027715454-skin@3x.webp',
        mobileWebIcon:
          'https://images.myloapp.in/NestJsUploads/1695027715454-skin@3x.webp',
        desktopIcon:
          'https://images.myloapp.in/NestJsUploads/1695027715454-skin@3x.webp',
        deeplink: 71,
        deeplinkValue: '/category/shop-by-concern-6117',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Care_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '4110',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Hair',
        icon: 'https://images.myloapp.in/NestJsUploads/1695027715456-hair@3x.webp',
        mobileWebIcon:
          'https://images.myloapp.in/NestJsUploads/1695027715456-hair@3x.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/shop-by-concern-6121',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Care_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '4115',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Fertility',
        icon: 'https://images.myloapp.in/NestJsUploads/1695027715457-fertility@3x.webp',
        mobileWebIcon:
          'https://images.myloapp.in/NestJsUploads/1695027715457-fertility@3x.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/by-life-goal-7010',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Care_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '4112',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Pregnancy & New Moms',
        icon: 'https://images.myloapp.in/NestJsUploads/1695027715457-Pregnancy-&-New-Moms@3x.webp',
        mobileWebIcon:
          'https://images.myloapp.in/NestJsUploads/1695027715457-Pregnancy-&-New-Moms@3x.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/by-life-goal-7006',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Care_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '4113',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Daily Wellness',
        icon: 'https://images.myloapp.in/NestJsUploads/1695027715458-Daily-Wellness@3x.webp',
        mobileWebIcon:
          'https://images.myloapp.in/NestJsUploads/1695027715458-Daily-Wellness@3x.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/by-life-goal-7015',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Care_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '4114',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Weight',
        icon: 'https://images.myloapp.in/NestJsUploads/1695028263081-weight@3x.webp',
        mobileWebIcon:
          'https://images.myloapp.in/NestJsUploads/1695028263081-weight@3x.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/by-concern-7027',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Care_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
    ],
    priority: 8,
    sectionBgImage: '',
    sectionBgColorStart: '#ffffff',
    sectionBgColorEnd: '#ffffff',
    objectId: 0,
    contentType: '',
    categoryTagIds: [4109, 4110, 4115, 4112, 4113, 4114],
    videoUrlData: {
      isAutoPlay: false,
      mute: false,
      playerType: 'youtube',
      videoUrl: '',
      thumbnailImage: '',
    },
    viewAllCtaDeeplinkValue: null,
    showViewAllCard: false,
    offerIds: [],
    timerOfferIds: [],
    tagIds: [],
    tagId: null,
    geoCheck: false,
    articleLimit: 10,
    articleTags: [],
    dietChartItem: false,
    feedingOptions: [],
    marqueeList: [
      {
        text: '',
        textColor: '#000000',
        image: '',
      },
    ],
    contentIds: [],
    tagBadgeData: null,
    extra: {
      utilityData: null,
    },
    clinicServiceType: [],
    htmlText: '',
    listItems: [],
    timeLimit: false,
    startTime: null,
    endTime: null,
    tagWebUrl: null,
    spinEligible: [2],
    formPoints: [],
    dsLabel: '',
    gradientList: [],
    isHorizontalScrollable: false,
    promotionalProgramId: '',
    ignoreStageRelevance: false,
    createdAt: '2023-03-16T07:41:40.682Z',
    updatedAt: '2023-06-27T09:42:02.699Z',
    __v: 0,
    deeplink: null,
    deeplinkValue: null,
    generalItemBgImage: '',
    subHeading: '',
    viewAllBannerImage: null,
    viewAllBannerImageHi: null,
    viewAllDeeplink: null,
    viewAllDeeplinkValue: null,
    userDx: [0, 1, 2, 3, 4, 5, 6, 7],
    isGeneralItem: true,
  },
  {
    _id: '3985',
    itemType: 'MYLO_CATEGORIES',
    itemName: 'Mylo Baby Categories',
    itemHeading: 'Explore Mylo Baby',
    heading: '',
    headingAlignment: 'TOP',
    headingRightIcon: '',
    cardView: true,
    showCta: false,
    getFromCache: false,
    viewType: 'GRID',
    gridSize: 3,
    items: [
      {
        _id: '7021',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Diapers & Wipes',
        icon: 'https://images.myloapp.in/dafault_tag.jpg',
        mobileWebIcon:
          'https://images.myloapp.in/products_category/168872696391.webp',
        desktopIcon:
          'https://images.myloapp.in/products_category/168318956222.webp',
        deeplink: 71,
        deeplinkValue: '/category/diapers-wipes-7021',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Baby_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '7022',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Baby Care',
        icon: 'https://images.myloapp.in/dafault_tag.jpg',
        mobileWebIcon:
          'https://images.myloapp.in/products_category/168621448363.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/baby-care-7022',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Baby_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '7023',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Baby Wellness',
        icon: 'https://images.myloapp.in/dafault_tag.jpg',
        mobileWebIcon:
          'https://images.myloapp.in/products_category/168872706326.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/baby-wellness-7023',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Baby_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '7024',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Baby Gear',
        icon: 'https://images.myloapp.in/dafault_tag.jpg',
        mobileWebIcon:
          'https://images.myloapp.in/products_category/168872699379.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/baby-gear-7024',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Baby_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '7025',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Baby Clothing',
        icon: 'https://images.myloapp.in/dafault_tag.jpg',
        mobileWebIcon:
          'https://images.myloapp.in/products_category/168872702491.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/baby-clothing-7025',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Baby_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
      {
        _id: '7063',
        categoryType: 'category',
        itemType: 'CATEGORY',
        name: 'Feeding & Lactation',
        icon: 'https://images.myloapp.in/dafault_tag.jpg',
        mobileWebIcon:
          'https://images.myloapp.in/products_category/168621446452.webp',
        desktopIcon: null,
        deeplink: 71,
        deeplinkValue: '/category/feeding-lactation-7063',
        itemSize: 'LARGE',
        sourceLogic: 'tech_logic',
        query_params:
          'utm_source=web&utm_medium=web_shop&utm_campaign=Mylo_Baby_Categories&utm_content=3985&source_logic=tech_logic&',
        isNewUx: false,
        cardView: true,
        textFlag: {},
      },
    ],
    priority: 8,
    sectionBgImage: '',
    sectionBgColorStart: '#ffffff',
    sectionBgColorEnd: '#ffffff',
    objectId: 0,
    contentType: '',
    categoryTagIds: [7021, 7022, 7023, 7024, 7025, 7063],
    videoUrlData: {
      isAutoPlay: false,
      mute: false,
      playerType: 'youtube',
      videoUrl: '',
      thumbnailImage: '',
    },
    viewAllCtaDeeplinkValue: null,
    showViewAllCard: false,
    offerIds: [],
    timerOfferIds: [],
    tagIds: [],
    tagId: null,
    geoCheck: false,
    articleLimit: 10,
    articleTags: [],
    dietChartItem: false,
    feedingOptions: [],
    marqueeList: [
      {
        text: '',
        textColor: '#000000',
        image: '',
      },
    ],
    contentIds: [],
    tagBadgeData: null,
    extra: {
      utilityData: null,
    },
    clinicServiceType: [],
    htmlText: '',
    listItems: [],
    timeLimit: false,
    startTime: null,
    endTime: null,
    tagWebUrl: null,
    spinEligible: [2],
    formPoints: [],
    dsLabel: '',
    gradientList: [],
    isHorizontalScrollable: false,
    promotionalProgramId: '',
    ignoreStageRelevance: false,
    createdAt: '2023-03-16T07:41:40.682Z',
    updatedAt: '2023-06-27T09:42:02.699Z',
    __v: 0,
    deeplink: null,
    deeplinkValue: null,
    generalItemBgImage: '',
    subHeading: '',
    viewAllBannerImage: null,
    viewAllBannerImageHi: null,
    viewAllDeeplink: null,
    viewAllDeeplinkValue: null,
    userDx: [0, 1, 2, 3, 4, 5, 6, 7],
    isGeneralItem: true,
  },
];
